<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems" />

      <d-col class="main-content mb-4 offset-lg-2 offset-md-3 p-0" tag="main" lg="10" md="9" sm="12">
        <!-- Content -->
        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';
import getSidebarUserItems from '@/data/sidebar-nav-items-user';
import MainSidebar from '@/components/layout/MainSidebar/MainSidebar.vue';

export default {
  name: 'main-view',
  components: {
    MainSidebar
  },
  data() {
    return {
      sidebarItems: JSON.parse(localStorage.getItem('user')).type === 'ADMIN' ? getSidebarItems() : getSidebarUserItems()
    };
  }
};
</script>

